import { Eye } from '@assets/svgs';
import { MobileColumnControl } from '@components/table/mobileComponents/MobileColumnControl';
import { TableGridBaseColDef } from '@components/table/types/TableColumnDef.type';
import { OverflowTooltip } from '@components/tooltip';
import { IconButton } from '@mui/material';
import { Box } from '@mui/system';
import { GridValidRowModel } from '@mui/x-data-grid';

export function formatColumnsForTable<T extends GridValidRowModel>({
  columns,
  isMobileScreen,
  columnVisibilityModel,
  visibleMobileColumnIndex,
  onSetVisibleMobileColumnIndex,
  onSetSelectedRow,
}: {
  isMobileScreen: boolean;
  visibleMobileColumnIndex: number;
  columns: TableGridBaseColDef<T>[];
  columnVisibilityModel?: any;
  onSetVisibleMobileColumnIndex: React.Dispatch<React.SetStateAction<number>>;
  onSetSelectedRow: React.Dispatch<React.SetStateAction<T>>;
}) {
  const index = columns.findIndex((col) => col?.mobileConfig?.mobileLockedColumn);
  const lockedIndex = index > -1 ? index : 0;

  let sortedColumns = columns;

  if (isMobileScreen) {
    // Move the locked column to the first position
    sortedColumns = [columns[lockedIndex], ...columns.slice(0, lockedIndex), ...columns.slice(lockedIndex + 1)];
  }

  const visibleColumns = sortedColumns?.filter((_, index) =>
    !isMobileScreen ? true : index === 0 || index === visibleMobileColumnIndex,
  );

  return [...visibleColumns]?.map((col, index) => {
    const newCol = { ...col };
    let renderHeader = newCol.renderHeader;
    let renderCell = newCol.renderCell;

    if (isMobileScreen && index !== 0) {
      renderHeader = () => {
        return (
          <MobileColumnControl
            columnsForScreenSize={columns}
            columnVisibilityModel={columnVisibilityModel}
            onSetVisibleMobileColumnIndex={onSetVisibleMobileColumnIndex}
            headerName={col.headerName ?? ''}
            lockedColumn={columns[lockedIndex].field}
          />
        );
      };

      renderCell = (params) => {
        return (
          <Box sx={{ position: 'relative' }}>
            <Box sx={{ marginRight: '60px', transform: 'translateX(30px)' }}>
              {newCol.renderCell ? (
                newCol.renderCell({ row: params.row, value: params.value })
              ) : (
                <OverflowTooltip>{params.value ? params.value.toString() : '-'}</OverflowTooltip>
              )}
            </Box>
            <IconButton
              onClick={() => onSetSelectedRow(params.row)}
              sx={{
                position: 'absolute',
                right: 0,
                top: 0,
              }}
            >
              <Eye />
            </IconButton>
          </Box>
        );
      };
    }

    return {
      ...newCol,
      align: isMobileScreen && index !== 0 ? 'center' : newCol.align,
      renderHeader,

      width: isMobileScreen ? newCol?.mobileConfig?.mobileWidth : newCol.width,
      flex: isMobileScreen ? (newCol?.mobileConfig?.mobileWidth ? undefined : 1) : newCol.flex,
      minWidth: isMobileScreen ? undefined : newCol.minWidth,
      renderCell:
        renderCell ||
        ((params: T['row']) => <OverflowTooltip>{params.value ? params.value?.toString() : '-'}</OverflowTooltip>),
    };
  });
}
